<template>
  <div class="FaqPage">
    <header-cmp />
    <main class="main-content">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="wysiwyg pt-11 pb-3" v-html="faqIntroText"></div>
            <accordion-extended
              class="pt-3 pb-11 no-borders"
              autoclose
              :items="accordions"
            >
              <template v-for="accordion in accordions" v-slot:[accordion.slot]>
                <div :key="accordion.id" v-html="accordion.text"></div>
              </template>
            </accordion-extended>
          </div>
        </div>
      </div>
    </main>
    <help-text />
    <footer-cmp />
    <app-loader-cmp />
    <svg-icons-cmp />
  </div>
</template>

<script>
import AppLoaderCmp from '@components/app-loader-cmp';
import FooterCmp from '@components/footer-cmp';
import HeaderCmp from '@components/header-cmp';
import SvgIconsCmp from '@components/svg-icons-cmp';
import AccordionExtended from '@components/accordion-extended';
import HelpText from '@components/help-text';

export default {
  name: 'FaqPage',
  components: {
    AppLoaderCmp,
    FooterCmp,
    HeaderCmp,
    SvgIconsCmp,
    AccordionExtended,
    HelpText,
  },
  computed: {
    faqIntroText() {
      // da sostituire con le faq corrette $context.cmsEntry.faq ???? non si sa ancora
      return (
        this.$context.faqContent.faq_content ||
        `
        <h2 style="text-align:center;color:#00a3e0;">Titolo pagina faq</h2>
        <p style="text-align:center;">Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris nisi ut aliquip ex ea commodo consequat.
                      Duis aute irure dolor in reprehenderit in voluptate velit
                      esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                      occaecat cupidatat non proident, sunt in culpa qui officia
                      deserunt mollit anim id est laborum.</p>
      `
      );
    },
    accordions() {
      // temporanea fino agli sviluppi be.
      // quando avremo $context.cmsEntry.accordion lo metteremo in questa variabile al posto della fixture
      const accordions = this.$context.faqContent.faq_accordions || [
        {
          id: 1,
          title: `Titolo 1 di prova`,
          text: `<p>TESTO 1Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris nisi ut aliquip ex ea commodo consequat.
                      Duis aute irure dolor in reprehenderit in voluptate velit
                      esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                      occaecat cupidatat non proident, sunt in culpa qui officia
                      deserunt mollit anim id est laborum.
                    </p>`,
        },
        {
          id: 2,
          title: `Titolo 2 di prova`,
          text: `<p>TESTO 2 Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris nisi ut aliquip ex ea commodo consequat.
                      Duis aute irure dolor in reprehenderit in voluptate velit
                      esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                      occaecat cupidatat non proident, sunt in culpa qui officia
                      deserunt mollit anim id est laborum.
                    </p>`,
        },
        {
          id: 3,
          title: `Titolo 3 di prova`,
          text: `<p>TESTO 3 Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris nisi ut aliquip ex ea commodo consequat.
                      Duis aute irure dolor in reprehenderit in voluptate velit
                      esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                      occaecat cupidatat non proident, sunt in culpa qui officia
                      deserunt mollit anim id est laborum.
                    </p>`,
        },
      ];

      return accordions.map((a) => {
        return {
          ...a,
          slot: `content-${a.id}`,
        };
      });
    },
  },
  mounted() {
    this.$store.dispatch('setLoading', false);
    this.$store.dispatch('setAppReady', true);
  },
};
</script>

<style lang="scss" scoped>
@import '~$scss/variables';

.FaqPage {
  .main-content {
    min-height: calc(
      100vh - #{fetch($header-height, xs)} - #{fetch($footer-height, xs)}
    );

    @include media-breakpoint-up(md) {
      min-height: calc(
        100vh - #{fetch($header-height, md)} - #{fetch($footer-height, md)}
      );
    }

    @include media-breakpoint-up(lg) {
      min-height: calc(
        100vh - #{fetch($header-height, lg)} - #{fetch($footer-height, lg)}
      );
    }
  }
}
</style>
